import request from '@/utils/httpClient'
import { ContactPayCreateParams, ContactPayUpdateParams } from '@/types/domain/customer'

// 创建客户联系人付款信息
export function createContactPay(data: ContactPayCreateParams) {
  return request({
    url: 'customerCompanyContactPay',
    method: 'POST',
    data
  })
}

// 更新客户联系人付款信息
export function updateContactPay(id: number, data: ContactPayUpdateParams) {
  return request({
    url: `customerCompanyContactPay/${id}`,
    method: 'put',
    data
  })
}

// 获取列表
export function getContactPayList(params?: object) {
  return request({
    url: 'customerCompanyContactPay',
    method: 'get',
    params
  })
}

// 获取详情
export function getContactPayById(id: number) {
  return request({
    url: `customerCompanyContactPay/${id}`,
    method: 'get'
  })
}

// 批量删除
export function deleteContactPayById(id: number) {
  return request({
    url: `customerCompanyContactPay/${id}`,
    method: 'delete'
  })
}

// 设置默认联系人
export function setDefaultContactPay(id: number) {
  return request({
    url: `customerCompanyContactPay/${id}`,
    method: 'put'
  })
}
